import React, { useState } from "react";
import { actions } from "../../../../../app/appSlice";
import { Divider, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useGetStudioIdQuery } from "../../../../../features/api/admin/gestisciStudioApi";
import { t } from "i18next";
import CoreDialog from "../../../../../app/core/components/CoreDialog/CoreDialog";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const ListsAdminStudios = ({ lists }) => {
  const dispatch = useDispatch();
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const studioId = useSelector((state) => state.app.studioId);
  const [selectStudio, setSelectStudio] = useState();
  const [changeStudio, setChangeStudio] = useState(false);

  const { data: getStudioId, isloading: loadingGet } = useGetStudioIdQuery(
    selectStudio?.studioId,
    {
      skip: !selectStudio?.studioId,
    }
  );

  const handleChangeStudio = (studio) => {
    setSelectStudio(studio);
    setChangeStudio(true);
  };

  const handleConfermStudio = () => {
    dispatch(
      actions.setStudioId({
        studioId: getStudioId.Data.id,
      })
    );
    dispatch(
      actions.updateStudioName({
        studioName: getStudioId.Data.name,
      })
    );

    dispatch(
      actions.setLogoImageURL({
        logoImageURL: getStudioId.Data.logoImageUrl,
      })
    );
    dispatch(
      actions.setColors({
        primaryColor: getStudioId.Data.primaryColor,
        secondaryColor: getStudioId.Data.secondaryColor,
      })
    );

    setTimeout(() => {
      window.location.reload();
    }, 750);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <h3 className="p-2 m-1" style={{ color: primaryColor }}>
          Lista studi
        </h3>
      </div>
      <Divider />
      {lists?.map((el, idx) => {
        const isSelected = studioId === el.studioId;
        return (
          <MenuItem
            key={idx}
            className="min-w-60 flex space-x-2"
            selected={isSelected}
            onClick={() => {
              if (!isSelected) handleChangeStudio(el);
            }}
          >
            <p className="text-sm font-semibold">{el.studioName}</p>
            {isSelected && (
              <CheckCircleRoundedIcon className=" text-green-600 " />
            )}
            <Divider />
          </MenuItem>
        );
      })}

      <CoreDialog
        open={changeStudio}
        title={`${t("SelectedStudio")} ${selectStudio?.studioName}`}
        content={t("ChangeStudio")}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermStudio}
        closeDialog={() => setChangeStudio(false)}
      />
    </div>
  );
};

export default ListsAdminStudios;
